<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'graduation-cap']" class="text-indigo-600 mr-2" />
            Applications by Program
        </h2>
        <div v-if="hasData">
            <apexchart type="bar" height="400" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📊</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgramBreakdownChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return [{
                name: 'Applications',
                data: this.data.map(item => item.count)
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(item => this.formatProgramName(item.program_name)),
                    title: { text: "Number of Students" },
                },
                colors: ['#3498DB'],
                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: '60%',
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Applications`,
                    },
                },
                grid: {
                    borderColor: '#f1f5f9',
                }
            };
        }
    },
    methods: {
        formatProgramName(name) {
            // Shorten long program names for better display
            if (name.length > 30) {
                return name.substring(0, 30) + '...';
            }
            return name;
        }
    }
};
</script>
